import { css } from 'emotion';
import * as React from 'react';
import If from '../If';

// const getDimensionsFromImageFile = imageFileObj =>
//   new Promise((resolve, reject) => {
//     const fr = new FileReader();

//     fr.onload = function() {
//       // file is loaded
//       const img = new Image();

//       img.onload = function() {
//         resolve({ width: img.naturalWidth, height: img.naturalHeight });
//         // alert(img.width); // image is loaded; sizes are available
//       };

//       img.src = fr.result; // is the data URL because called with readAsDataURL
//     };

//     fr.readAsDataURL(imageFileObj); // I'm using a <input type="file"> for demonstrating
//   });
const noop = () => null;

interface ImageProps {
  renderLoadingPlaceholder: () => React.ReactNode;
  height: number | string;
  width: number | string;
  imageUrl: string;
  retinaImageUrl: string;
  objectFit: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
}
interface ImageState {
  isImageLoaded: boolean;
}

const defaultProps = {
  retinaImageUrl: null,
  renderLoadingPlaceholder: noop,
  height: 'auto',
  width: '100%',
  objectFit: 'fill',
};

class Image extends React.Component<ImageProps, ImageState> {
  public static defaultProps = defaultProps;
  constructor(props: ImageProps) {
    super(props);
    this.state = {
      isImageLoaded: false,
    };
  }

  public handleImageLoaded = () => {
    this.setState(() => ({
      isImageLoaded: true,
    }));
  };

  public render() {
    const { isImageLoaded } = this.state;
    const {
      renderLoadingPlaceholder,
      height,
      width,
      imageUrl,
      objectFit,
      retinaImageUrl,
    } = this.props;
    const heightAndWidthStyle = {
      height,
      width,
    };
    const rootClassName = css({
      display: 'inline-block',
      ...heightAndWidthStyle,
    });
    const imageContainerClassName = css({
      height,
      width,
      display: isImageLoaded ? 'block' : 'none',
    });
    const imageClassName = css({
      ...heightAndWidthStyle, // TODO: maybe just make this 100% width and height
      verticalAlign: 'top', // Why? https://stackoverflow.com/questions/5804256/image-inside-div-has-extra-space-below-the-image/5804278
      objectFit,
    });
    const loadingPlaceholderContainerClassName = css({
      display: 'inline-block',
    });

    return (
      <div className={rootClassName}>
        <div className={imageContainerClassName}>
          <img
            srcSet={
              retinaImageUrl ? `${imageUrl} 1x, ${retinaImageUrl} 2x` : ''
            }
            src={imageUrl}
            alt="grumpy cat"
            onLoad={() => {
              this.handleImageLoaded();
            }}
            className={imageClassName}
          />
        </div>
        <div
          className={loadingPlaceholderContainerClassName}
          style={{
            ...heightAndWidthStyle, // TODO: maybe just make this 100% width and height
            display: isImageLoaded ? 'none' : 'block',
          }}
        >
          {renderLoadingPlaceholder()}
        </div>
      </div>
    );
  }
}

export { Image as default, Image };
